export const version = "4.1.0";
export const navbarBreakPoint = "xl";
export const topNavbarBreakpoint = "lg";

// Pilot list for the Analytics entry point in the top nav.
// Keep in sync with CMS: traya-crm-next-gen/src/config/config.ts (ANALYTICS_EMAIL_WHITELIST)
export const ANALYTICS_EMAIL_WHITELIST = [
  "abhinav@trayahealth.com",
  "abhinav@traya.health",
  "agarwalsandip@traya.health",
  "altaf@traya.health",
  "sudiptadas@traya.health",
  "sultantippu@traya.health",
  "paritosh@traya.health",
  "ankitkhandelwal@traya.health",
  "omkar@traya.health",
  "ankita@traya.health",
  "chinmaykorgaonkar@traya.health",
  "tanishakumari@traya.health",
  "nikit@traya.health",
  "dishavarshney@traya.health"
];
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: "vertical",
  currency: "$",
  isNavbarVerticalCollapsed: true,
  navbarStyle: "vibrant",
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };

export const QA_FORM_FILLED_PURPOSE = {
  FORM_AUDIT_BY_QA: 'AUDIT',
  FORM_AUDIT_BY_QA_TL: 'RE_AUDIT',
  FORM_AUDIT_BY_QA_TL_BUT_DISPUTED_BY_COACH: 'DISPUTED'
};

export const cannotCreateStatus = [
  "delivered",
  "in_progress",
  "shipped",
  "shipping_pending",
  "void",
];

// Statuses on the latest customer order that trigger a duplicate-order warning
// before allowing a new order to be created. Allow list: "cancelled", "void", "delivered"
export const DUPLICATE_ORDER_BLOCK_STATUSES = [
  "pending_prescription",
  "shipping_pending",
  "shipped",
  "in_progress", // "Out For Delivery" in UI
];

export const comboProductMappings = [
  "ffcfa776-4576-4d52-bf34-953d93440c06",
  "f4e03119-3cef-48cf-bcab-36a589c1494e",
  "c40c2c8c-a701-4482-b85e-0fdc1d019da5",
  "667a5bf6-5246-4107-ad3b-206499529f37",
  "cc18f8a1-d935-49f2-8ed4-12c3a98aa90c",
  "b5fad2f2-f265-46cb-867e-8535b04b91cb",
  "cb4ab01f-3eda-4378-9888-6aeecfb75207",
  "e531aa1a-d081-432e-a4d8-2283058e4138",
  "c77b52fe-24d6-4418-9a70-9d01599669ce",
  "4a2a77a4-c77c-4aa4-ab5c-09f7ac6cc9f3",
  "7edd4829-ee6d-4927-ae1b-1981611ab937",
];

export const requiredWarehouses = {
  VAPI: "VAPI Warehouse",
  BAN: "Prozo Banglore",
  GG: "Prozo Gurgaon",
  BHW_SAIRAJ: "Bhiwandi Sairaj Warehouse",
};

export const lagger = [
  { label: "True", value: true },
  { label: "False", value: false },
];

export const disablledKeysCMS = [
  "taskName",
  "navigation",
  "eventName",
  "type",
  "isActive",
  "isDietPlanExist",
  "orderCount",
  "weekNumber",
  "displayOptionNumber",
  "minReorderDays",
  "maxReorderDays",
  "displayOptionNumber",
  "gender",
  "language",
  "images",
  "rootCauseMasterIds",
  "color1",
  "color2",
];

export const notToShowInCMS = [
  "id",
  "createdAt",
  "h1Text",
  "h2Text",
  "backgroundColour",
  "footerText",
];

const timeSlots = {
  "00:00": false,
  "00:30": false,
  "01:00": false,
  "01:30": false,
  "02:00": false,
  "02:30": false,
  "03:00": false,
  "03:30": false,
  "04:00": false,
  "04:30": false,
  "05:00": false,
  "05:30": false,
  "06:00": false,
  "06:30": false,
  "07:00": false,
  "07:30": false,
  "08:00": false,
  "08:30": false,
  "09:00": false,
  "09:30": false,
  "10:00": false,
  "10:30": false,
  "11:00": false,
  "11:30": false,
  "12:00": false,
  "12:30": false,
  "13:00": false,
  "13:30": false,
  "14:00": false,
  "14:30": false,
  "15:00": false,
  "15:30": false,
  "16:00": false,
  "16:30": false,
  "17:00": false,
  "17:30": false,
  "18:00": false,
  "18:30": false,
  "19:00": false,
  "19:30": false,
  "20:00": false,
  "20:30": false,
  "21:00": false,
  "21:30": false,
  "22:00": false,
  "22:30": false,
  "23:00": false,
  "23:30": false,
};
export const initialSlots = {
  0: timeSlots,
  1: timeSlots,
  2: timeSlots,
  3: timeSlots,
  4: timeSlots,
  5: timeSlots,
  6: timeSlots,
};

export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const canAccessMedicalEngagements = ["medical", "admin", "super_admin"];

export const locationFilters = [
  "Malad",
  "WFH",
  "Thane",
  "Fusion Mumbai",
  "Fusion Kolkata",
  "TechnoTask Mumbai",
  "TechnoTask Bhopal",
  "CNX Mumbai",
  "Squadstacks Mumbai",
  "Voitek Mumbai",
  "Pune",
  "Kochar tech Amritsar",
  'Radical Minds Bangalore',
  'DRIT Mohali'
];

export const weekFilter = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
  "Rotational",
];

export const timeOptions = ["10:00-19:00", "10:00-19:30", "11:30-21:00"];

export const userHouseConfig = ['In-house', 'Outsource'];

export const languageBarriersDisposition = [
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "kannada", label: "Kannada" },
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "malayalam", label: "Malayalam" },
  { value: "marathi", label: "Marathi" },
];

export const pcDispositionLanguages = [
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "tamil", label: "Tamil" },
  { value: "telugu", label: "Telugu" },
  { value: "kannada", label: "Kannada" },
  { value: "malayalam", label: "Malayalam" },
  { value: "marathi", label: "Marathi" },
  { value: "other", label: "Other" },
];

export const NULL_VALUES = [null, 'undefined', undefined, 'null'];

export const formDisposition = ["unanswered", "languageIssue", "dndMode"];

export const LEAVE_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};

export const AGENT_LANGUAGES = {
  TAMIL: "Tamil",
  TELUGU: "Telugu",
  KANNADA: "Kannada",
  MALAYALAM: "Malayalam",
  MARATHI: "Marathi",
  ENGLISH: "English",
  NA: "NA"
};

export const MUTATION_FLAGS = {
  DELETE: 0,
  ADD: 1,
	UPDATE: 2
};

export const TAG_ID = '14211dd7-9a45-46db-b6f5-69cd1fe969e8';

export const UNANSWERED_OPTION = ["Week #1", "retention", "Week #3", "w0_call", "SLOT_BOOKING"];

export const UNANSWER_ENG = ["week_1", "retention", "week_3", "w0_call", "prescription_call", "slot_booking", "winback"];

export const attemptOption = [
  { label: "Yet To picked", value: "yet-to-pickup" },
  { label: "Inprogress", value: "in progress" },
  { label: "Completed", value: "completed" },
];

export const MALE_STAGE = [
  "",
  "stage-1",
  "stage-2",
  "stage-3",
  "stage-4",
  "stage-5",
  "stage-6",
  "Heavy Hair Fall",
  "Coin size patches",
  "Not a scalp image",
];

export const FEMALE_STAGE = [
  "",
  "Hair Thinning",
  "Heavy Hair Fall",
  "Heavy Hair Fall Across The Head",
  "Heavy Hair fall across the head",
  "Heavy Hair loss",
  "Mild Hair Fall",
  "Side Thinning",
  "Less volume on the sides",
  "Volume Loss",
  "Texture Loss",
  "No widening",
  "Medium Widening",
  "Starting to see widening",
  "Advanced Widening",
  "side_widening",
  "Advanced widening",
  "Early Widening",
  "Mild widening",
  "Coin size patches",
  "Not a scalp image",
];

const designation = {
  MBBS: "MBBS",
  BAMS: "BAMS",
  BHMS: "BHMS",
  OTHER: "OTHER"
}

export const MEDICAL_ESCALATION_INTERVENTION_DOCTOR = [
	{
		'doctors': {
			[designation.MBBS]: ['dr.sharan@traya.health', 'dr.suhasini@traya.health', 'dr.shashank@traya.health', 'dr.swapnil@traya.health', 'drreena@traya.health', 'siddhirp@gmail.com', 'dravtarsinh@traya.health'],
			[designation.BHMS]: ['dr.deepika@traya.health', 'dr.aisha@traya.health', 'dr.shivani@traya.health', 'ketaki.sankheb@gmail.com', 'sddrsukrutha@gmail.com', 'drdeepak@traya.health', 'nandinishetty@traya.health'],
      [designation.BAMS]: ['afreensayyed@traya.health', 'darshana@traya.health', 'oshinrajeev@traya.health'],
      [designation.OTHER]: ['drdivyapoulose@traya.health', 'rajkumarpal@traya.health', 'nandinishetty@traya.health', 'dravtarsinh@traya.health', 'siddhirp@gmail.com', 'drreena@traya.health']

		},
		'subcategories': {
			[designation.MBBS]: ['boils_issue', 'itching_issue', 'swelling_issue', 'sexual_issue', 'dandruff_issue', 'product_reaction_issue', 'no_results_dandruff', 'other_issue', 'health_issue', 'generic_health', 'non_alcohol_minoxidil_concerns'],
			[designation.BHMS]: ['deterioration', 'hairfall_issue', 'no_results_with_traya', 'five_months_no_results', 'case_deterioration', 'doctor_call', 'hairfall_increase_issue', 'angry_customer', 'negative_review', 'coach_service'],
			[designation.BAMS]: ['gastric_issue', 'constipation_issue', 'no_results_oral_supplements', 'medical_document'],
      [designation.OTHER]: ['five_month_money_back']
		}
	}

];

export const REALLOCATE_USER_EMAIL_ACCESS = [
  "rajeshyadav@traya.health",
  "sayedasad@traya.health",
];

export const CATEGORY_DOCTOR_FLAG = ['slot_missed',  'slot_not_catered', 'customer_others',  'negative_reviews_orm', 'community_escalation']

export const CLINIC_VISIT_REQUEST_TYPE = [
  'store_app_booking',
  'store_website_booking',
  'store_app_lead_booking',
  'store_website_lead_booking'
];

// Channel an NPS response came from. Mirrors npsfeedbacks.source, which the
// backend defaults to APP — historical rows predate the field entirely, so a
// missing value also means APP.
export const NPS_SOURCE = {
  APP: 'APP',
  WHATSAPP: 'WHATSAPP'
};

export const NPS_SOURCE_LABELS = {
  [NPS_SOURCE.APP]: 'App',
  [NPS_SOURCE.WHATSAPP]: 'WhatsApp'
};
